import Vue from 'vue';
import * as types from '../mutation-types';

// initial state
const state = {
  page: {},
  lang: 0,
  blur: false,
  theme: 'white',
};

// getters
const getters = {
  page: stateFreezed => stateFreezed.page,
  theme: stateFreezed => stateFreezed.theme,
  lang: stateFreezed => stateFreezed.lang,
  blur: stateFreezed => stateFreezed.blur,
};

// actions
const actions = {
  fetchPage({ commit, dispatch }, params) {
    Vue.http.get(`/pages/${params.slug}/`)
    .then((response) => {
      // get body data
      commit(types.RECEIVE_PAGE, response.body);
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_PAGE](stateFreezed, pageFetched) {
    const st = stateFreezed;
    st.page = pageFetched;
  },
  [types.CHANGE_THEME](stateFreezed, theme) {
    const st = stateFreezed;
    st.theme = theme;
  },
  [types.CHANGE_BLUR](stateFreezed, status) {
    const st = stateFreezed;
    st.blur = status;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/page.js